(() => {
  if (window.collectionCardOptionsLoaded) return;
  window.collectionCardOptionsLoaded = true;
  const cache = new WeakMap();
  function update(control, changedIndex, changedValue) {
    const card = control.closest('.grid-product');
    if (!card) return;
    if (!cache.has(control)) {
      const source = control.querySelector('[data-catalog-variants]');
      cache.set(control, source ? JSON.parse(source.textContent) : []);
    }
    const variants = cache.get(control);
    if (!variants.length) return;
    const choices = [];
    control.querySelectorAll('[data-catalog-option]').forEach(select => {
      choices[Number(select.dataset.catalogOption)] = select.value;
    });
    control.querySelectorAll('[data-catalog-color][aria-pressed="true"]').forEach(button => {
      choices[Number(button.dataset.catalogIndex)] = button.dataset.catalogColor;
    });
    choices[changedIndex] = changedValue;
    const exact = variants.filter(v => v.options.every((value, index) => value === choices[index]));
    let variant = exact.find(v => v.available) || exact[0];
    if (!variant) {
      const matches = variants.filter(v => v.options[changedIndex] === changedValue);
      variant = matches.find(v => v.available) || matches[0];
    }
    if (!variant) return;
    control.querySelectorAll('[data-catalog-option]').forEach(select => {
      select.value = variant.options[Number(select.dataset.catalogOption)];
    });
    control.querySelectorAll('[data-catalog-color]').forEach(button => {
      const selected = variant.options[Number(button.dataset.catalogIndex)];
      button.setAttribute('aria-pressed', String(button.dataset.catalogColor === selected));
      const label = control.querySelector('[data-catalog-color-name]');
      if (label) label.textContent = selected;
    });
    card.querySelectorAll('.grid-product__link, [data-catalog-view]').forEach(link => link.setAttribute('href', variant.url));
    const price = card.querySelector('.grid-product__price');
    if (price) {
      const original = price.querySelector('.grid-product__price--original');
      if (original) {
        original.hidden = !variant.comparePrice;
        if (variant.comparePrice) original.textContent = variant.comparePrice;
      }
      const current = price.querySelector('span:not(.visually-hidden):not(.grid-product__price--original)');
      if (current) {
        current.textContent = variant.price;
        current.classList.toggle('sale-price', Boolean(variant.comparePrice));
      }
    }
    const stock = control.querySelector('[data-catalog-stock]');
    if (stock) stock.hidden = variant.available;
    const soldOut = card.querySelector('.grid-product__tag--sold-out');
    if (soldOut) soldOut.hidden = variant.available;
    const image = card.querySelector('.product-image-frame img');
    if (image && variant.image) {
      image.removeAttribute('srcset');
      image.src = variant.image;
      image.alt = variant.alt;
      const secondary = card.querySelector('.grid-product__secondary-image');
      if (secondary) secondary.hidden = true;
    }
  }
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-catalog-option]')) return;
    const control = event.target.closest('[data-catalog-options]');
    if (control) update(control, Number(event.target.dataset.catalogOption), event.target.value);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-catalog-color]');
    if (!button) return;
    const control = button.closest('[data-catalog-options]');
    if (control) update(control, Number(button.dataset.catalogIndex), button.dataset.catalogColor);
  });
})();
